import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const FIELDS = [
  ["contact_email", "İletişim E-postası"],
  ["tiktok", "TikTok Linki"],
  ["instagram", "Instagram Linki"],
  ["youtube", "YouTube Linki"],
  ["x", "X (Twitter) Linki"],
  ["seo_title", "SEO Başlık"],
  ["seo_description", "SEO Açıklama"],
  ["og_image", "OG Görsel URL"],
];

export default function SettingsPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setData(r.data.settings || {}));
  }, []);

  const save = async () => {
    await api.put("/admin/content/settings", data);
    toast.success("Ayarlar kaydedildi");
  };

  if (!data) return <p className="text-[#525252]">Yükleniyor...</p>;

  return (
    <div data-testid="admin-settings" className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-8">Ayarlar</h1>
      <div className="space-y-4">
        {FIELDS.map(([key, label]) => (
          <div key={key}>
            <label className="text-xs text-[#525252] uppercase tracking-wider block mb-1.5">{label}</label>
            <input data-testid={`setting-${key}`} className="field-dark" value={data[key] ?? ""} onChange={(e) => setData((d) => ({ ...d, [key]: e.target.value }))} />
          </div>
        ))}
        <button data-testid="settings-save-btn" onClick={save} className="flex items-center gap-2 bg-[#8B0000] hover:bg-[#C1121F] px-5 py-2.5 text-xs tracking-wider uppercase transition-colors">
          <Save size={14} /> Kaydet
        </button>
      </div>
    </div>
  );
}
